import gql from 'graphql-tag'

export const RESET_SECURE_VAULT_USER = gql`
  mutation resetSecureVaultUser($sub: String!) {
    resetSecureVaultUser(sub: $sub)
  }
`
